import React, { useState } from 'react';
import AppHeader from './components/AppHeader';
import { ErrorMessage } from './components/Common/ErrorMessage';
import { ImagePreview } from './components/Settings/ImagePreview';
import { RenderingLoader } from './components/Settings/RenderingLoader';
import { SidePanelLeft } from './components/SidePanelLeft';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <AppHeader sidebarOpen={sidebarOpen} onToggleSidebar={() => setSidebarOpen(o => !o)} />
      <div className="shell">
        <div className={`sidebar${sidebarOpen ? ' mobile-open' : ''}`}>
          <SidePanelLeft />
        </div>
        <div
          className={`sidebar-overlay${sidebarOpen ? ' mobile-open' : ''}`}
          onClick={() => setSidebarOpen(false)}
        />
        <ImagePreview />
      </div>
      <RenderingLoader />
      <ErrorMessage />
    </>
  );
}

export default App;
